import * as React from "react";
import { useSearchParams } from "react-router-dom";
import ResetPassword from "@route-planner/components/ResetPassword";

const Component = (props) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return <ResetPassword token={token} />;
};

const page = {
  routeProps: {
    path: "ResetPassword",
    component: Component,
  },
  name: "Reset Password",
  label: "Reset Password",
  title: "Reset Password",
  showOnMenu: false,
};

export default page;
